import { render, staticRenderFns } from "./BonASavoir.vue?vue&type=template&id=04f31401&"
import script from "./BonASavoir.vue?vue&type=script&lang=js&"
export * from "./BonASavoir.vue?vue&type=script&lang=js&"
import style0 from "./BonASavoir.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports